import { baseSpacing } from '../../base/tokens/spacing'

// should match base values until we have a need for different values
export const journeyUiSpacing = { ...baseSpacing }
